import { 
  // Clear, 
  ExpandLess, 
  ExpandMore 
} from '@mui/icons-material';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { useState } from 'react';

import { NContact } from '@modules/ContactManager/components/Tabs/components/Contact/validation';
import { ShadowDivider } from '@shared/styledComponents';
import { LenderSectionDivider } from '@styles/ContactManager/DealCalculator/LenderSectionStyles';
import {
  Body,
  Header,
  IconWrapper,
  LenderContainer,
  LenderHeader,
  LenderNames,
  LendersList,
  RelativeFlexWrapper,
  // RemoveButton,
  Title,
  Titles,
  TitlesFooter
} from '@styles/ContactManager/DealCalculator/LendersStyles';
import { IMap } from '@shared/interfaces';
import { DefaultValuationMethods } from '../../interfaces';
import { DealCalculatorModel } from '../../models/DealCalculatorModel';
// import { IEligibleLender } from '../../models/EligibleLenderModel';
import { ExcludedLenderSection } from './components/ExcludedLendersSection';
import { CreditRulesTypes } from './components/LenderSection/LenderCreditRules';
import { LenderSection } from './components/LenderSection/LenderSection';
// import { ExcludeReasonModal } from './ExcludeReasonModal';

interface IDealCalculatorLendersProps {
  formProps: FormikProps<DealCalculatorModel>;
  leadId?: string;
  dealId?: string;
  contactAddress?: NContact.Address;
  coContactId?: string;
  assetId: string;
  setFieldValue: <T>(field: string, value: T, shouldValidate?: boolean) => void;
  reloadDealCalculator: () => void;
  isVoidEnable: boolean;
  setNewDealId: React.Dispatch<React.SetStateAction<string | null>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  reloadContactAlerts: () => void;
}

export const DealCalculatorLenders = ({
  formProps,
  leadId,
  dealId,
  contactAddress,
  coContactId,
  assetId,
  setFieldValue,
  reloadDealCalculator,
  setNewDealId,
  setLoading,
  isVoidEnable,
  reloadContactAlerts,
}: IDealCalculatorLendersProps) => {
  const [selectedLender, setSelectedLender] = useState(0);
  const { values: data } = formProps;

  const [expanded, setExpanded] = useState<IMap<boolean>>({});

  const isExpanded = (section: string) => !!expanded[section];
  const toggle = (section: string) => {
    setExpanded({ ...expanded, [section]: !expanded?.[section] });
  };

  // const [isModalExcluedeOpen, setIsModalExcluedeOpen] = useState(0);
  // const [excludedLender, setExcludedLender] = useState<IEligibleLender | null>(null);

  return (
    <Box display="flex">
      <LenderContainer>
        <Header>
          <Typography
            variant="h3"
            sx={{ mr: '140px' }}
          >
            Lenders
          </Typography>
          <LenderNames>
            {data?.eligibleLenders?.map((lender, idx) => (
              <LenderHeader
                key={lender.id}
                onClick={() => setSelectedLender(idx)}
              >
                <Box display="flex" flexDirection="column" alignItems="flex-start">
                  <Typography
                    component="div"
                    sx={{
                      font: 'inherit',
                      color: 'inherit',
                      pl: 1,
                      pb: 0.5,
                    }}
                  >
                    {lender.name}
                  </Typography>

                  <FormControlLabel
                    label="Declined"
                    control={
                      <Checkbox
                        checked={!!lender.inputs?.isDeclined}
                        size="medium"
                        onChange={(_, checked) =>
                          setFieldValue?.(`eligibleLenders[${idx}].inputs.isDeclined`, checked)
                        }
                      />
                    }
                    sx={{
                      mt: 0.5,
                      ml: 0,
                      '& .MuiFormControlLabel-label': {
                        color: 'text.primary',
                        fontSize: '0.875rem',
                        fontWeight: 400,
                      },
                    }}
                    onClick={(event) => event.stopPropagation()}
                  />
                </Box>

                {/* {selectedLender !== idx && (
                  <RemoveButton
                    onClick={(e) => {
                      e.stopPropagation();
                      setExcludedLender(lender);
                      setIsModalExcluedeOpen((prevState) => prevState + 1);
                    }}
                  >
                    <Clear sx={{ width: '14px' }} />
                  </RemoveButton>
                )} */}
              </LenderHeader>
            ))}
          </LenderNames>
        </Header>

        <ShadowDivider regular />

        <Box
          display="flex"
          mr="1px"
        >
          <Titles>
            <Title onClick={() => toggle('valuation')}>
              <IconWrapper>{isExpanded('valuation') ? <ExpandLess /> : <ExpandMore />}</IconWrapper>
              Valuation
            </Title>
            {isExpanded('valuation') && (
              <Box sx={{ paddingLeft: '25px' }}>
                {Object.values(DefaultValuationMethods).map((valuationMethod) => (
                  <Title key={valuationMethod}>{valuationMethod}</Title>
                ))}
              </Box>
            )}
            <Title>Borrower Default Score</Title>
            <Title>Lender Preferred Score (Borrower)</Title>
            <Title>CoBorrower Default Score</Title>
            <Title>Lender Preferred Score (CoBorrower)</Title>
            <Title>Max Cash Out</Title>
            <Title>Cash Out</Title>
            <Title>Max LTV</Title>
            <Title>LTV (FE or All-In)</Title>
            <Title>Required Down Payment</Title>
            <Title>Down Payment</Title>
            <Title>Max Term</Title>
            <Title>Term</Title>

            <LenderSectionDivider dense />

            <Typography
              variant="h3"
              sx={{ mb: '5px' }}
            >
              Products
            </Typography>

            <Title>Maximum</Title>

            <Title onClick={() => toggle('vsc')}>
              <IconWrapper>{isExpanded('vsc') ? <ExpandLess /> : <ExpandMore />}</IconWrapper>
              VSC Retail
            </Title>

            {isExpanded('vsc') && (
              <Box sx={{ paddingLeft: '25px' }}>
                <Title>Max VSC</Title>
                <Title>VSC Cost</Title>
                <Title>VSC Markup</Title>
                <Title>VSC Plan</Title>
              </Box>
            )}

            <Title onClick={() => toggle('mbi')}>
              <IconWrapper>{isExpanded('mbi') ? <ExpandLess /> : <ExpandMore />}</IconWrapper>
              MBI Retail
            </Title>

            {isExpanded('mbi') && (
              <Box sx={{ paddingLeft: '25px' }}>
                <Title>Max MBI</Title>
                <Title>MBI Cost</Title>
                <Title>MBI Markup</Title>
                <Title>MBI Plan</Title>
              </Box>
            )}

            <Title onClick={() => toggle('gap')}>
              <IconWrapper>{isExpanded('gap') ? <ExpandLess /> : <ExpandMore />}</IconWrapper>
              GAP Retail
            </Title>

            {isExpanded('gap') && (
              <Box sx={{ paddingLeft: '25px' }}>
                <Title>Max GAP</Title>
                <Title>GAP Cost</Title>
                <Title>GAP Markup</Title>
                <Title>GAP Plan</Title>
              </Box>
            )}

            <Title onClick={() => toggle('com')}>
              <IconWrapper>{isExpanded('com') ? <ExpandLess /> : <ExpandMore />}</IconWrapper>
              COM Retail
            </Title>

            {isExpanded('com') && (
              <Box sx={{ paddingLeft: '25px' }}>
                <Title>Max COM</Title>
                <Title>COM Cost</Title>
                <Title>COM Markup</Title>
                <Title>COM Plan</Title>
              </Box>
            )}
            <Title onClick={() => toggle('paf')}>
              <IconWrapper>{isExpanded('paf') ? <ExpandLess /> : <ExpandMore />}</IconWrapper>
              PAF Retail
            </Title>

            {isExpanded('paf') && (
              <Box sx={{ paddingLeft: '25px' }}>
                <Title>Max PAF</Title>
                <Title>PAF Cost</Title>
                <Title>PAF Markup</Title>
                <Title>PAF Plan</Title>
              </Box>
            )}
            <Title onClick={() => toggle('vrp')}>
              <IconWrapper>{isExpanded('vrp') ? <ExpandLess /> : <ExpandMore />}</IconWrapper>
              VRP Retail
            </Title>

            {isExpanded('vrp') && (
              <Box sx={{ paddingLeft: '25px' }}>
                <Title>Max VRP</Title>
                <Title>VRP Cost</Title>
                <Title>VRP Markup</Title>
                <Title>VRP Plan</Title>
              </Box>
            )}
            <LenderSectionDivider dense />

            <Typography
              variant="h3"
              sx={{ mb: '5px' }}
            >
              Lender Results
            </Typography>

            <Title>Rate Markup</Title>
            <Title onClick={() => toggle('rateBlock')}>
              <IconWrapper>{isExpanded('rateBlock') ? <ExpandLess /> : <ExpandMore />}</IconWrapper>
              Approved Rate
            </Title>
            {isExpanded('rateBlock') && (
              <Box sx={{ paddingLeft: '25px' }}>
                <Title>Buy Rate</Title>
                <Title>Total Rate Adjustments</Title>
                <Title>Net Rate</Title>
              </Box>
            )}
            <Title>Ttl Amt Financed BF Tax</Title>
            <Title>Sales Tax</Title>
            <Title>Product Sales Tax</Title>
            <Title>Total Amount Financed</Title>
            <Title>Payment</Title>
            <Title>Last Payment</Title>
            <Title>Max/ Actual DTI</Title>
            <Title>Max / Actual PTI</Title>
            <Title>Ranking</Title>

            <TitlesFooter>
              <Title>Total GP</Title>
              <Title>GP VRP</Title>
              <Title>Rate Savings</Title>
              <Title>Pmt Savings</Title>
              <Title>Required Down Payment</Title>

              <Box height={5} />
            </TitlesFooter>
            <LenderSectionDivider dense />

            <Typography
              variant="h3"
              sx={{ mb: '5px' }}
            >
              Lender Credit Rules (exp)
            </Typography>

            {Object.values(CreditRulesTypes).map((ruleType: string) => (
              <Title key={ruleType}>{ruleType}</Title>
            ))}

            <LenderSectionDivider
              dense
              style={{ marginTop: '4px' }}
            />

            <Typography
              variant="h3"
              sx={{ mb: '5px', gap: 0, cursor: 'pointer' }}
              onClick={() => toggle('pitch')}
            >
              <IconWrapper>{isExpanded('pitch') ? <ExpandLess /> : <ExpandMore />}</IconWrapper>
              Pitch Details
            </Typography>

            {isExpanded('pitch') && (
              <>
                <Title>Estimated Refunds</Title>
                <Title>Contract Date</Title>
                <Title>1st Pmt Days</Title>
                <Title>1st Pmt Date</Title>
                <Title>Effective Term @ Current Pmt</Title>
                <Title>Variable Pmt</Title>
                <Title>Effective Term @ Variable Pmt</Title>
                <Title>Deal Status</Title>
              </>
            )}
            <LenderSectionDivider dense />
          </Titles>

          <RelativeFlexWrapper>
            <LendersList>
              {data?.eligibleLenders?.map((lender, idx) => (
                <LenderSection
                  key={lender.id}
                  leadId={leadId}
                  dealId={dealId}
                  contactAddress={contactAddress}
                  assetId={assetId}
                  formProps={formProps}
                  idx={idx}
                  lender={lender}
                  isSelected={selectedLender === idx}
                  coContactId={coContactId}
                  setNewDealId={setNewDealId}
                  setBtnLoading={setLoading}
                  setSelected={() => setSelectedLender(idx)}
                  isExpanded={isExpanded}
                  isVoidEnable={isVoidEnable}
                  reloadDealCalculator={reloadDealCalculator}
                  reloadContactAlerts={reloadContactAlerts}
                />
              ))}
            </LendersList>
          </RelativeFlexWrapper>
        </Box>
      </LenderContainer>

      <Body>
        <ExcludedLenderSection
          ineligibleLenders={data?.ineligibleLender ?? []}
          leadId={leadId}
          reloadDealCalculator={reloadDealCalculator}
        />
      </Body>
      {/* <ExcludeReasonModal
        excludeReasonModalPositon={isModalExcluedeOpen}
        handleClose={() => setIsModalExcluedeOpen(0)}
        lender={excludedLender}
        leadId={leadId || ''}
        reloadDealCalculator={reloadDealCalculator}
      /> */}
    </Box>
  );
};
